import { Draggable } from "react-beautiful-dnd";
import { GripVertical, Move } from "lucide-react";
import { cn } from "@/lib/utils";

interface DraggableVisualizationCardProps {
  id: string;
  index: number;
  children: React.ReactNode;
  isEditMode?: boolean;
}

export const DraggableVisualizationCard = ({ id, index, children, isEditMode = false }: DraggableVisualizationCardProps) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!isEditMode}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={cn(
            "relative transition-all duration-200",
            isEditMode && "cursor-grab active:cursor-grabbing",
            isEditMode && !snapshot.isDragging && "ring-2 ring-primary/30 ring-offset-2 ring-offset-background rounded-xl",
            snapshot.isDragging && "z-50 rotate-1 scale-[1.02] shadow-2xl ring-2 ring-primary"
          )}
        >
          {/* Edit Mode Indicator Banner */}
          {isEditMode && (
            <div
              className={cn(
                "absolute -top-3 left-1/2 -translate-x-1/2 z-10 px-3 py-1 rounded-full",
                "bg-primary text-primary-foreground text-xs font-medium shadow-lg",
                "flex items-center gap-1.5",
                snapshot.isDragging && "scale-110"
              )}
            >
              <Move className="h-3 w-3" />
              <span>Arrastrar</span>
            </div>
          )}
          {children}
        </div>
      )}
    </Draggable>
  );
};
